import { Pipe, PipeTransform, Component, ViewChild, NgZone } from '@angular/core';
import { Network } from '@ionic-native/network';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Events, MenuController, Nav, IonicPage } from 'ionic-angular';
import { AccountPage } from '../pages/account/account';
import { AccountHomePage } from '../pages/account/account-home';
import { LoginPage } from '../pages/login/login';
import { CommonData } from '../providers/common-data';
import { ParplatzData } from '../providers/pp-data';
import { UserData } from '../providers/user-data';
import { UEData } from '../providers/ue-data';
import { TasksData } from '../providers/tasks-data';

import { EinsatzplanData } from '../providers/einsatzplan-data';
import { PpmapComponent } from '../components/ppmap/ppmap';

import { KontrollenData } from '../pages/kontrollen/kontrollen-data';
import { KontrolleData } from '../providers/kontrolle-data';
import { NotificationData } from '../providers/notification-data';
import { NotificationListPage } from '../pages/notifications/notification-list';

import { ParkkontrollenCreatePage } from '../pages/parkkontrollen/parkkontrollen-create';
import { UECreatePage } from '../pages/ue/ue-create';
import { UEUploadPage } from '../pages/ue/ue-upload';
import { UEModel } from '../pages/ue/ue-model';
import { PPListPage } from '../pages/pp-list/pp-list';
import { UEListPage } from '../pages/ue-list/ue-list';
import { UESearchPage } from '../pages/ue-list/ue-search';
import { EinsatzplanListPage } from '../pages/einsatzplan/einsatzplan-list';
import { UEDetailPage } from '../pages/ue-list/ue-detail';
import { UEEditPage } from '../pages/ue-list/ue-edit';
import { BlockingtimeListPage } from '../pages/blockingtime/blockingtime-list';
import { Platform } from 'ionic-angular';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';

import moment from 'moment';

import { EmployeeavalabilityData } from '../pages/employeeavailability/employeeavailability-data';
import { EmployeeavalabilityListPage } from '../pages/employeeavailability/employeeavailability-list';
import { ParkbewilligungenListPage } from '../pages/parkbewilligungen/parkbewilligungen-list';
import { AntraegeListPage } from '../pages/parkbewilligungen/antraege/antraege-list';
import { PbkategorienPage } from '../pages/parkbewilligungen/pbkategorien/pbkategorien';
import { PbzonenPage } from '../pages/parkbewilligungen/pbzonen/pbzonen';
import { ParkbewilligungenData } from '../pages/parkbewilligungen/parkbewilligungen-data';
import { AgGridAngular } from 'ag-grid-angular';
import { MandantenData } from '../providers/mandanten-data';

import { AdminPage } from '../pages/admin/admin';
import { PbAdminPage } from '../pages/parkbewilligungen/pbadmin/pbadmin';
import { GolinksPage } from '../pages/parkbewilligungen/golinks/golinks';
import { TasksPage } from '../pages/tasks/tasks';


export interface PageObj {
  title: string;
  component: any;
  icon: string;
  logsOut?: boolean;
  index?: number;
  viewmode?: string;
  count: number;
}

@Component({
  templateUrl: 'app.template.html'
})
export class PXUpload2App {
  // the root nav is a child of the root app component
  // @ViewChild(Nav) gets a reference to the app's root nav
  @ViewChild(Nav) nav: Nav;
  
  // List of pages that can be navigated to from the left menu
  // the left menu only works after login
  // the login page disables the left menu
  appPages: Array<PageObj> = [];
  appPagesPb: Array<PageObj> = [];
  loggedInPages: PageObj[] = [
    { title: 'Home', component: AccountHomePage, icon: 'home', count:-1 },
    { title: 'Profil', component: AccountPage, icon: 'person', count:-1 },
    { title: 'Nachrichten', component: NotificationListPage, icon: 'mail', count:-1 },
    
//    { title: 'Logout', component: TabsPage, icon: 'log-out', logsOut: true }
  ];
  loggedOutPages: PageObj[] = [
    { title: 'Login', component: LoginPage, icon: 'log-in', count:-1 }
    //{ title: 'Signup', component: SignupPage, icon: 'person-add' }
  ];
  rootPage: any = PPListPage;

  constructor(
    public events: Events,
    public userData: UserData,
    public menu: MenuController,
    public platform: Platform,
    public ppData: ParplatzData,
    public kontrolleData: KontrolleData,
    public notificationData: NotificationData,
    public commonData: CommonData,
    public ueData: UEData,
    public epData: EinsatzplanData,
    ueModel: UEModel,
    common: CommonData,
    public zone: NgZone,
    public statusBar: StatusBar, 
    public splashScreen: SplashScreen,
    public network: Network,
    public pbData: ParkbewilligungenData,
    public mandantenData: MandantenData
    ,public taskData: TasksData

  ) {
    // Call any initial plugins when ready
    platform.ready().then(() => {
       statusBar.styleDefault();
       splashScreen.hide();
       
    });

    // decide which menu items should be hidden by current login status stored in local storage
    this.userData.checkLoginToken().then(data => {
      //data[1]= user id 
     
      if(typeof data !== "undefined" && data[1]>0){
        // load the conference data        
        Promise.all([
            ppData.load(),            
          ]).then(data => {
            this.events.publish('user:login');
            //this.nav.setRoot(PPListPage);            
          });


      }
      else{       
        this.nav.setRoot(LoginPage);
      }
      
    });
    /*
    this.userData.checkLogin().then((hasLoggedIn) => {
      this.enableMenu(hasLoggedIn === true);
    });
    */

    let disconnectSubscription = network.onDisconnect().subscribe(() => {
      this.zone.run(() => {       
        common.wifierror = "Keine Datenverbindung";
      });
    });       

    let connectSubscription = network.onConnect().subscribe(() => {
      //console.log('network connected!');
        this.zone.run(() => {       
          common.wifierror = "";
        });
      setTimeout(() => {
        if (network.type === 'wifi') {
          console.log('we got a wifi connection, woohoo!');
        }
      }, 3000);
    });    

    this.listenToLoginEvents();

    events.subscribe('updatecounter', (title, count) => {

      for(let i=0; i<this.loggedInPages.length; i++){
        if(this.loggedInPages[i].title == title){
          this.zone.run(() => {       
            this.loggedInPages[i].count = count;      
          });          
          
        }
      }
      
      for(let i=0; i<this.appPages.length; i++){
        if(this.appPages[i].title == title){
          this.zone.run(() => {       
            this.appPages[i].count = count;      
          });          
          
        }
      }

      for(let i=0; i<this.appPagesPb.length; i++){
        //console.log(this.appPagesPb[i].component.name );
        //console.log(this.appPagesPb[i].component.name);
        if(this.appPagesPb[i].title == title){          
          this.zone.run(() => {       
            this.appPagesPb[i].count = count;      
          });              
          
        }
      }
      
      
    });

  }//constructor

  handleLoginError(){
    console.log('Login error');
  }

  buildMenu(){
    this.appPages.length = 0;
    this.appPagesPb.length = 0;

    
    if(this.userData.isAllowed("22","r") ){
      this.loggedInPages.push({ title: 'Tasks', component: TasksPage, icon: 'checkbox-outline', count:-1 });
    }    

    if((this.userData.isAllowed("1","c") && this.platform.is('cordova') || this.userData.isAllowed("5","s1"))){
      this.appPages.push({ title: 'Kontrolle starten', component: PPListPage, icon: 'add', viewmode:'createue', count:-1 });
    }    

    
    if(this.userData.isAllowed("1","r")){
      this.appPages.push({ title: 'Umtriebsentschädigungen', component: UESearchPage, icon: 'list', count:-1 });
    }    
    if(this.userData.isAllowed("2","r")){
      this.appPages.push({ title: 'Einsatzplan', component: EinsatzplanListPage, icon: 'calendar', count:-1 });
    }    
    
    if(this.userData.isAllowed("14","r")){
      this.appPages.push({ title: 'Verfügbarkeit', component: EmployeeavalabilityListPage, icon: 'ice-cream', count:-1 });
    }    
    if(this.userData.isAllowed("3","r")){
      this.appPages.push({ title: 'Sperrzeiten/Ausnahmeinfo', component: BlockingtimeListPage, icon: 'hand', count:-1 });
    }    
    if(this.userData.isAllowed("4","r")){
      this.appPages.push({ title: 'Parkplätze', component: PPListPage, icon: 'pin', viewmode:'pplist', count:-1 });
    }        
    if((this.userData.usergroup_id == 1) && this.platform.is("cordova")){
      this.appPages.push({ title: 'Parkkontrollen', component: ParkkontrollenCreatePage, icon: 'qr-scanner', count:-1});
    }
    if((this.userData.usergroup_id == 1) ){
      this.appPages.push({ title: 'Admin', component: AdminPage, icon: 'briefcase', count:-1});
    }

    if(this.userData.isAllowed("17","r")){
      this.appPagesPb.push({ title: 'Aufgaben', component: AntraegeListPage, icon: 'clipboard', count:-1});
    }    

    if(this.userData.isAllowed("15","r")){
      this.appPagesPb.push({ title: 'Parkbewilligungen', component: ParkbewilligungenListPage, icon: 'ribbon', count:-1});
    }    
    if(this.userData.isAllowed("16","r")){

      this.appPagesPb.push({ title: 'Kategorien', component: PbkategorienPage, icon: 'filing', count:-1});
    }    
    if(this.userData.isAllowed("18","r")){      
      this.appPagesPb.push({ title: 'Zonen', component: PbzonenPage, icon: 'map', count:-1});
    }
    if(this.userData.isAllowed("21","r")){      
      this.appPagesPb.push({ title: 'Links', component:     GolinksPage    , icon: 'link', count:-1});
    }

    if((this.userData.usergroup_id == 1) ){
      this.appPagesPb.push({ title: 'PbAdmin', component: PbAdminPage, icon: 'briefcase', count:-1});
    }


    

  }

  openPage(page: PageObj) {
    // the nav component was found using @ViewChild(Nav)
    // reset the nav to remove previous pages and only have this page
    // we wouldn't want the back button to show in this scenario
    this.commonData.actpageviewmode = page.viewmode;
    if (page.index) {
      this.nav.setRoot(page.component, {tabIndex: page.index});

    } else {
      this.nav.setRoot(page.component);
    }

    if (page.logsOut === true) {
      // Give the menu time to close before changing to logged out
      setTimeout(() => {
        this.userData.logout();
      }, 1000);
    }
  }


  listenToLoginEvents() {
    this.events.subscribe('user:login', () => {
    Promise.all([
        this.ppData.load(),  
        //this.notificationData.load(),
        this.userData.loadACL(),          
        this.userData.loadEmployees(),          
        this.kontrolleData.loadKontrollenStatus(),        
        this.pbData.load(),  
        this.mandantenData.load(),
        this.taskData.takscount()
      ]).then(data => {
        this.buildMenu();  
        //console.log(this.userData.acl);
        this.nav.setRoot(AccountHomePage);      

      });      
      
      
    this.enableMenu(true);
    });

    this.events.subscribe('user:signup', () => {
      this.enableMenu(true);
    });

    this.events.subscribe('user:logout', () => {
      this.enableMenu(false);
      this.ppData.clear();
      this.ueData.clear();
      this.epData.clear();
      this.appPages.length = 0;
      this.appPagesPb.length = 0;
      this.nav.setRoot(LoginPage);      
    });
 
  }

  enableMenu(loggedIn) {
    this.menu.enable(loggedIn, 'loggedInMenu');
    this.menu.enable(!loggedIn, 'loggedOutMenu');
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts